import React, { Children } from 'react';
const PrivacyPolicyPage = () => {
  return <div data-id="element-420">
      {/* Hero Section */}
      <section className="bg-[#0a3d62] text-white py-16" data-id="element-421">
        <div className="container mx-auto px-4" data-id="element-422">
          <div className="max-w-3xl mx-auto text-center" data-id="element-423">
            <h1 className="text-3xl md:text-4xl font-bold mb-6" data-id="element-424">
              Privacy & Cookie Policy
            </h1>
            <p className="text-lg text-gray-200" data-id="element-425">
              Information about how we collect, use, and protect your data
            </p>
          </div>
        </div>
      </section>
      {/* Policy Content */}
      <section className="py-16" data-id="element-426">
        <div className="container mx-auto px-4" data-id="element-427">
          <div className="max-w-3xl mx-auto" data-id="element-428">
            <div className="prose prose-lg max-w-none" data-id="element-429">
              <h2 className="text-2xl font-bold text-[#0a3d62] mb-6" data-id="element-430">
                Privacy and Cookie Policy - PinnacleHub
              </h2>
              <p className="mb-6" data-id="element-431">
                At PinnacleHub, protecting your privacy is a priority. This
                policy explains what information we collect, how we use it, and
                how we keep it secure, ensuring you have confidence in our
                handling of your personal data.
              </p>
              <h3 className="text-xl font-semibold text-[#0a3d62] mt-8 mb-4" data-id="element-432">
                1. Who We Are
              </h3>
              <p className="mb-6" data-id="element-433">
                PinnacleHub is a UK-based appliance repair and service company
                specializing in essential household systems and appliances.
              </p>
              <h3 className="text-xl font-semibold text-[#0a3d62] mt-8 mb-4" data-id="element-434">
                2. What Information We Collect
              </h3>
              <p className="mb-6" data-id="element-435">
                We may collect the following information from you to provide our
                services and manage your account effectively:
              </p>
              <ul className="list-disc pl-6 mb-6" data-id="element-436">
                <li className="mb-2" data-id="element-437">
                  <strong data-id="element-438">Your name and contact details:</strong> Including your
                  address, email (Bikashbuddha2004@gmail.com), and phone number
                  (0800 055 4969).
                </li>
                <li className="mb-2" data-id="element-439">
                  <strong data-id="element-440">Payment information:</strong> Processed securely
                  through our trusted payment providers.
                </li>
                <li className="mb-2" data-id="element-441">
                  <strong data-id="element-442">
                    Records of your service plans and repair history:
                  </strong>{' '}
                  To ensure continuity of service and support.
                </li>
              </ul>
              <h3 className="text-xl font-semibold text-[#0a3d62] mt-8 mb-4" data-id="element-443">
                3. How We Use Your Information
              </h3>
              <p className="mb-6" data-id="element-444">We use your data primarily to:</p>
              <ul className="list-disc pl-6 mb-6" data-id="element-445">
                <li className="mb-2" data-id="element-446">
                  <strong data-id="element-447">Manage and administer your service plans:</strong>{' '}
                  Including activation, renewals, and plan adjustments.
                </li>
                <li className="mb-2" data-id="element-448">
                  <strong data-id="element-449">Arrange repairs and provide customer support:</strong>{' '}
                  Dispatching engineers and addressing your queries.
                </li>
                <li className="mb-2" data-id="element-450">
                  <strong data-id="element-451">Send important updates and information:</strong>{' '}
                  Related to your service, appointments, and policy changes.
                </li>
                <li className="mb-2" data-id="element-452">
                  <strong data-id="element-453">Comply with legal and regulatory obligations:</strong>{' '}
                  Ensuring we operate within the law.
                </li>
              </ul>
              <h3 className="text-xl font-semibold text-[#0a3d62] mt-8 mb-4" data-id="element-454">
                4. Third-Party Providers
              </h3>
              <p className="mb-6" data-id="element-455">
                We work with trusted third parties, such as payment processors
                and website hosting providers, to deliver our services
                efficiently and securely. We want to assure you that we do not
                sell your personal information to any third parties.
              </p>
              <h3 className="text-xl font-semibold text-[#0a3d62] mt-8 mb-4" data-id="element-456">
                5. Cookies
              </h3>
              <p className="mb-6" data-id="element-457">
                Our website uses cookies to enhance your browse experience and
                improve site performance. Cookies are small data files stored on
                your device that help us understand how you interact with our
                site. You can manage or disable cookies through your browser
                settings at any time, but please note this may affect certain
                website functionalities.
              </p>
              <h3 className="text-xl font-semibold text-[#0a3d62] mt-8 mb-4" data-id="element-458">
                6. Your Rights
              </h3>
              <p className="mb-6" data-id="element-459">
                Under applicable data protection laws, you have specific rights
                regarding your personal data. You have the right to:
              </p>
              <ul className="list-disc pl-6 mb-6" data-id="element-460">
                <li className="mb-2" data-id="element-461">
                  Request access to the personal data we hold about you.
                </li>
                <li className="mb-2" data-id="element-462">
                  Ask for corrections or deletion of your data.
                </li>
                <li className="mb-2" data-id="element-463">
                  Withdraw your consent to marketing communications at any time.
                </li>
              </ul>
              <p className="mb-6" data-id="element-464">
                To exercise these rights, please contact us at:
              </p>
              <ul className="list-disc pl-6 mb-6" data-id="element-465">
                <li className="mb-2" data-id="element-466">📧 Bikashbuddha2004@gmail.com</li>
                <li className="mb-2" data-id="element-467">📞 0800 055 4969</li>
              </ul>
              <h3 className="text-xl font-semibold text-[#0a3d62] mt-8 mb-4" data-id="element-468">
                7. Sharing Your Data
              </h3>
              <p className="mb-6" data-id="element-469">We may share your information with:</p>
              <ul className="list-disc pl-6 mb-6" data-id="element-470">
                <li className="mb-2" data-id="element-471">
                  <strong data-id="element-472">
                    Service providers essential to our operations:
                  </strong>{' '}
                  Such as payment processors, IT support, and website hosting
                  services, who act on our behalf.
                </li>
                <li className="mb-2" data-id="element-473">
                  <strong data-id="element-474">Law enforcement or regulatory authorities:</strong>{' '}
                  When required by law or in response to a valid legal request.
                </li>
                <li className="mb-2" data-id="element-475">
                  <strong data-id="element-476">Marketing partners:</strong> But only with your
                  explicit consent, which you can withdraw at any time.
                </li>
              </ul>
              <h3 className="text-xl font-semibold text-[#0a3d62] mt-8 mb-4" data-id="element-477">
                8. Data Retention
              </h3>
              <p className="mb-6" data-id="element-478">
                We retain your personal data only as long as necessary to:
              </p>
              <ul className="list-disc pl-6 mb-6" data-id="element-479">
                <li className="mb-2" data-id="element-480">
                  Provide and manage our services to you effectively.
                </li>
                <li className="mb-2" data-id="element-481">
                  Comply with legal and regulatory requirements.
                </li>
                <li className="mb-2" data-id="element-482">Resolve disputes or complaints.</li>
              </ul>
              <h3 className="text-xl font-semibold text-[#0a3d62] mt-8 mb-4" data-id="element-483">
                9. Children's Privacy
              </h3>
              <p className="mb-6" data-id="element-484">
                Our services are not intended for individuals under 16 years
                old. We do not knowingly collect personal data from minors. If
                we become aware that such data has been collected, we will take
                steps to delete it.
              </p>
              <h3 className="text-xl font-semibold text-[#0a3d62] mt-8 mb-4" data-id="element-485">
                10. Data Security
              </h3>
              <p className="mb-6" data-id="element-486">
                We implement strong security measures, including technical and
                organizational safeguards, to protect your information from
                unauthorized access, accidental loss, destruction, or
                alteration. While we strive for robust security, please
                understand that no system can guarantee 100% security during
                data transmission over the internet.
              </p>
              <h3 className="text-xl font-semibold text-[#0a3d62] mt-8 mb-4" data-id="element-487">
                11. International Data Transfers
              </h3>
              <p className="mb-6" data-id="element-488">
                Your data may be stored or processed outside the UK or European
                Economic Area by our service providers. Where this happens, we
                ensure appropriate safeguards are in place to protect your data
                in accordance with relevant data protection laws.
              </p>
              <h3 className="text-xl font-semibold text-[#0a3d62] mt-8 mb-4" data-id="element-489">
                12. Updates to This Policy
              </h3>
              <p className="mb-6" data-id="element-490">
                We may update this privacy policy occasionally to reflect
                changes in our practices, technology, or legal requirements. Any
                changes will be published here with the updated date. We
                encourage you to review this policy regularly to stay informed.
              </p>
              <h3 className="text-xl font-semibold text-[#0a3d62] mt-8 mb-4" data-id="element-491">
                13. Contact Us
              </h3>
              <p className="mb-6" data-id="element-492">
                If you have any questions or concerns about your data or this
                policy, please do not hesitate to contact us:
              </p>
              <ul className="list-disc pl-6 mb-6" data-id="element-493">
                <li className="mb-2" data-id="element-494">📧 Bikashbuddha2004@gmail.com</li>
                <li className="mb-2" data-id="element-495">📞 0800 055 4969</li>
              </ul>
            </div>
          </div>
        </div>
      </section>
    </div>;
};
export default PrivacyPolicyPage;